var UrlQueryLocaleSource_1;
import { __decorate } from "tslib";
import { injectable } from "inversify";
import { LocaleSource } from "./LocaleSource";
import { LocaleObject } from "../../locale/Locale";
import { extractQueryParamsFromUrl } from "../../../util/url";
let UrlQueryLocaleSource = UrlQueryLocaleSource_1 = class UrlQueryLocaleSource extends LocaleSource {
    static withConfig(config) {
        let ConfiguredUrlQueryLocaleSource = class ConfiguredUrlQueryLocaleSource extends UrlQueryLocaleSource_1 {
            constructor() {
                super(...arguments);
                this.config = config;
            }
        };
        ConfiguredUrlQueryLocaleSource = __decorate([
            injectable()
        ], ConfiguredUrlQueryLocaleSource);
        return ConfiguredUrlQueryLocaleSource;
    }
    getLocales() {
        const params = this.config?.params ?? [];
        const locales = [];
        const urlParams = extractQueryParamsFromUrl(window.location.href);
        const acceptedParams = params.map(x => urlParams.get(x));
        for (const p of acceptedParams) {
            if (!p)
                continue;
            const parsed = LocaleObject.tryParse(p);
            if (!parsed)
                continue;
            locales.push(parsed);
        }
        return Promise.resolve(locales);
    }
};
UrlQueryLocaleSource = UrlQueryLocaleSource_1 = __decorate([
    injectable()
], UrlQueryLocaleSource);
export { UrlQueryLocaleSource };
//# sourceMappingURL=UrlQueryLocaleSource.js.map